export default __webpack_public_path__ + "static/pa-4a8f311a05e660425ae111d60b7e787e.svg";